export default __webpack_public_path__ + "static/media/about-sheme.2f830f1e.png";